// recon-loans-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcn.docStatus.validForPeriod': 'Gyldig for perioden',
  'rcn.docStatus.carriedForward': 'Fremført til periodeslutt',
  'rcn.docStatus.needsCarryForward': 'Krever fremføring',
  'rcn.docStatus.wrongPeriod': 'Feil periode',
  'rcn.docStatus.incomplete': 'Ufullstendig dokumentasjon',
  'rcn.docStatus.wrongCompany': 'Feil selskap',
  'rcn.docStatus.missing': 'Mangler',
  'rcn.docIssue.none': 'Ingen innvending',
  'rcn.docIssue.wrongCompany': 'Gjelder feil selskap',
  'rcn.docIssue.incomplete': 'Ufullstendig dokumentasjon',
  'rcn.repaymentType.serial': 'Serielån — like store avdrag',
  'rcn.repaymentType.annuity': 'Annuitetslån — like store terminbeløp',
  'rcn.repaymentType.interestOnly': 'Avdragsfritt — bare renter',
  'rcn.repaymentType.unknown': 'Ukjent / annet',
  'rcn.check.unregistered': 'Gjeldskontoer uten registrert lån',
  'rcn.check.documentation': 'Lån uten gyldig dokumentasjon for perioden',
  'rcn.check.plan': 'Lån uten nedbetalingsplan',
  'rcn.check.interest': 'Lån med påløpte renter som ikke er bokført',
  'rcn.check.fees': 'Lån med gebyrer som ikke er bokført',
  'rcn.check.currency': 'Lån i utenlandsk valuta',
  'rcn.check.unclassified': 'Bokført gjeld utenfor kort- og langsiktig gjeld',
});
